import React from 'react';
import styled from 'styled-components';

const Title = styled.div`
  font-family: Courier;
  text-align: center;
  font-size: 4rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    font-size: 1.5rem;
    margin-bottom: ${({ theme }) => theme.spacing.sm};
  }
`;

const SubTitle = styled.span`
  font-size: 0.8em;
  opacity: 0.6;
`;

function Logo() {
  return (
    <Title>
      Something&nbsp;
      <SubTitle>relates to</SubTitle>
      &nbsp;Anything
    </Title>
  );
}

export default Logo;
